import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './flashdeal.css';

export default class FlashDeals extends Component {
    render() {
        return (
            <>
            <div className="flash-deals-doot-com-webversion-main-sectionx">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="flash-deal-wexv-dot-main-sec-bboxx-web-version">
                                <div className="flash-dott-ccm-dealmmnnff-bb-web-verrsn">
                                    <p><span><img src={require('../../../assets/flashdeal-icon.svg')} alt="orponbd global collections"/></span> Flash Deals</p>
                                    <Link to="/flash-deal-all-products"><span>View More <i className="fa fa-angle-right"></i></span></Link>
                                </div>

                                <div className="row flash-dott-com-delproj-rww-webb-versnn">
                                    <div className="col-md-2 col-6">
                                        <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-1.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <h3><span>৳</span> 1200</h3>
                                                    <h4><del><span>৳</span> 1500</del></h4>
                                                    <div className="flash-ddll-doot-com-ooffwr-webb-versn">
                                                        <p>15% off</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-2.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                <h3><span>৳</span> 1200</h3>
                                                    <h4><del><span>৳</span> 1500</del></h4>
                                                    <div className="flash-ddll-doot-com-ooffwr-webb-versn">
                                                        <p>15% off</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-3.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <h3><span>৳</span> 1200</h3>
                                                    <h4><del><span>৳</span> 1500</del></h4>
                                                    <div className="flash-ddll-doot-com-ooffwr-webb-versn">
                                                        <p>15% off</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-4.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <h3><span>৳</span> 1200</h3>
                                                    <h4><del><span>৳</span> 1500</del></h4>
                                                    <div className="flash-ddll-doot-com-ooffwr-webb-versn">
                                                        <p>15% off</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-5.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <h3><span>৳</span> 1200</h3>
                                                    <h4><del><span>৳</span> 1500</del></h4>
                                                    <div className="flash-ddll-doot-com-ooffwr-webb-versn">
                                                        <p>15% off</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-6.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="flash-deal-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <h3><span>৳</span> 1200</h3>
                                                    <h4><del><span>৳</span> 1500</del></h4>
                                                    <div className="flash-ddll-doot-com-ooffwr-webb-versn">
                                                        <p>15% off</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }
}
